module.exports = "/call-frontend/img/icon_export_outline.d4770939.svg";